import {useEffect, useState} from 'react'

const useVoucherTypeEvent = (voucherData) => {
	const [voucherTypeList, setVoucherTypeList] = useState([])

	// Initialize from API data, sorted by idx
	useEffect(() => {
		if (voucherData) {
			const sortedData = [...voucherData].sort((a, b) => a.idx - b.idx)
			const formattedList = sortedData.map((elem) => ({
				idx: elem.idx,
				name: elem.name,
				expiration_days: elem.expiration_days,
				isNew: false,
			}))
			setVoucherTypeList(formattedList)
		}
	}, [voucherData])

	const updateVoucherName = (index, name) => {
		const newList = [...voucherTypeList]
		newList[index] = {...newList[index], name}
		setVoucherTypeList(newList)
	}

	const updateVoucherExpiration = (index, expiration_days) => {
		const newList = [...voucherTypeList]
		newList[index] = {...newList[index], expiration_days}
		setVoucherTypeList(newList)
	}

	const addNewVoucher = () => {
		const newVoucher = {
			idx: null, // null indicates new item
			name: '',
			expiration_days: 30,
			isNew: true,
		}
		setVoucherTypeList([...voucherTypeList, newVoucher])
	}

	const removeVoucher = (index) => {
		if (voucherTypeList.length <= 1) {
			alert('최소 1개의 매장 이용권 유형은 유지되어야 합니다.')
			return
		}

		const voucher = voucherTypeList[index]
		if (voucher.name) {
			const newList = [...voucherTypeList]
			newList.splice(index, 1)
			setVoucherTypeList(newList)
		}
	}

	return {
		voucherTypeList,
		updateVoucherName,
		updateVoucherExpiration,
		addNewVoucher,
		removeVoucher,
	}
}

export default useVoucherTypeEvent
